// Login.js
import React, { useState, useEffect } from "react";
import LoginForm from "./LoginForm";
import RegistrationForm from "./RegistrationForm";
import { login, registration, requestRetrievePassword } from "../pages/api";
import { Link, Navigate, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import PasswordResetForm from "./retrievePasswordForm";
import { EmbeddedCheckout } from "@stripe/react-stripe-js";

const API_URL = process.env.REACT_APP_API_URL;

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isPasswordHidden, setHidePassword] = useState(true);
  const [emailSelectedLogin, setEmailSelectedLogin] = useState(false);
  const [passwordSelectedLogin, setPasswordSelectedLogin] = useState(false);
  const [name, setName] = useState("");
  const [lastname, setLastName] = useState("");
  const [emailSelectedRegistration, setEmailSelectedRegistration] =
    useState(false);
  const [nameSelected, setNameSelected] = useState(false);
  const [lastNameSelected, setLastNameSelected] = useState(false);
  const [passwordSelectedRegistration, setPasswordSelectedRegistration] =
    useState(false);
  const [toggleForm, setToggleForm] = useState(false);
  const [isValidLength, setIsValidLength] = useState(false);
  const [isValidUpperCase, setIsValidUpperCase] = useState(false);
  const [isValidLowerCase, setIsValidLowerCase] = useState(false);
  const [isValidNumber, setIsValidNumber] = useState(false);
  const [isValidSpecialCharacter, setIsValidSpecialCharacter] = useState(false);
  const [isLoginSuccess, setLoginSuccess] = useState(null);
  const [userAlreadyExist, setUserAlreadyExist] = useState(false);
  const [loginError, setLoginError] = useState(null);
  const [registrationError, setRegistrationError] = useState(null);
  const [showPasswordResetForm, setShowPasswordResetForm] = useState(false); // Nuovo stato per gestire la visualizzazione del form di reset
  const [loginEmailError, setLoginEmailError] = useState(null);
  const [registrationPasswordError, setRegistrationPasswordError] =
    useState(null);
  const [registrationEmailError, setRegistrationEmailError] = useState(null);
  const [registrationFirstNameError, setRegistrationFirstNameError] =
    useState(null);
  const [registrationLastNameError, setRegistrationLastNameError] =
    useState(null);

  const navigate = useNavigate();
  const location = useLocation();
  //const from = location.state?.from?.pathname || "/";
  const from = location.state?.from || "/";

  const expired = location.state || null;
  useEffect(() => {
    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response.status === 403) {
          console.log("You do not have permission to access this resource.");
          setLoginError("You do not have permission to access this resource.");
        } else if (error.response.status === 409) {
          console.log(
            "Sembra che un altro account sia già associato a questa email."
          );
          setLoginError(
            "Sembra che un altro account sia già associato a questa email."
          );
          setUserAlreadyExist(true);
        } /* else {
          console.log("An error occurred:", error.response.status);
          setLoginError("An error occurred. Please try again.");
        }*/
        return Promise.reject(error);
      }
    );
  }, []);

  //GOOGLE LOGIN
  const handleLoginSuccess = async (response) => {
    try {
      console.log("Login Success:", response);
      const googleToken = response.credential;

      // Invia il token di Google al backend
      const res = await axios.post(`${API_URL}/api/google-login`, {
        token: googleToken,
      });

      console.log("Response from backend:", res.data);

      // Controlla la risposta dal backend
      if (res.status === 200) {
        const data = res.data; // Dati restituiti dal backend

        console.log("Dati restituiti dal backend:", data);

        // Salva il JWT nel localStorage
        if (res.data.user) {
          localStorage.setItem("user", JSON.stringify(res.data.user));
        }

        await setLoginSuccess(true);
      } else {
        console.error("Errore durante l'autenticazione:", res.status, res.data);
      }
    } catch (error) {
      console.error("Errore:", error.message || error);
    }
  };

  const handleLoginError = () => {
    console.log("Login Failed");
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginError(null);
    setLoginSuccess(false);
    console.log(from);
    try {
      const result = await login(email.toLowerCase(), password);
      if (result.success) {
        console.log("Login successful:", result.user);
        await setLoginSuccess(true);

        // Esegui eventuali azioni di successo del login, come il reindirizzamento alla pagina del profilo
      } else {
        setLoginError(result.message);
        setLoginSuccess(false);
      }
    } catch (error) {
      console.error("Unexpected error during login:", error);
      setLoginError("An unexpected error occurred. Please try again later.");
      setLoginSuccess(false);
    }
  };

  const handleRegistration = async (e) => {
    e.preventDefault();
    setLoginError(null);
    setLoginSuccess(false);
    setRegistrationEmailError(null);
    setRegistrationFirstNameError(null);
    setRegistrationLastNameError(null);

    try {
      const response = await registration(name, lastname, email, password);
      console.log("Registration successful:", response);
      await login(email, password);

      setLoginSuccess(true);
    } catch (error) {
      if (error.message.toLowerCase().includes("email")) {
        setRegistrationEmailError(error.message);
      } else if (error.message.toLowerCase().includes("password")) {
        setRegistrationPasswordError(error.message);
      } else if (error.message.toLowerCase().includes("first name")) {
        setRegistrationFirstNameError(error.message);
      } else if (error.message.toLowerCase().includes("last name")) {
        setRegistrationLastNameError(error.message);
      } else {
        setRegistrationError(error.message);
      }
      //setRegistrationError(error.message);
      console.error("Registration error:", error.message);
    }
  };

  const handleEmail = (event) => {
    setEmail(event.target.value);
  };

  const handlePassword = (value) => {
    setIsValidLength(value.length >= 8);

    setIsValidUpperCase(/^(?=.*[A-Z]).*$/.test(value));
    //console.log("Maiuscola: ", isValidUpperCase);
    setIsValidLowerCase(/^(?=.*[a-z]).*$/.test(value));
    //console.log("Minuscola: ", isValidLowerCase);
    setIsValidNumber(/^(?=.*\d).*$/.test(value));
    //console.log("Numero: ", isValidNumber);
    setIsValidSpecialCharacter(/^(?=.*[!@#$%^&.*]).*$/.test(value));
    //console.log("Carattere speciale:", isValidSpecialCharacter);

    const isValidPassword =
      isValidLength &&
      isValidUpperCase &&
      isValidLowerCase &&
      isValidNumber &&
      isValidSpecialCharacter;
    console.log("La password è valida:", isValidPassword);

    setPassword(value);
  };

  useEffect(() => {
    if (isLoginSuccess) {
      navigate(from, { replace: true });
    }
  }, [isLoginSuccess, navigate, from]);
  //<div className="min-h-screen flex flex-col justify-center items-center bg-gray-200">

  const passwordForgot = async (e) => {
    e.preventDefault();
    console.log("setShowPasswordResetForm");
    setShowPasswordResetForm(true);
  };

  const handleRetrievePassword = async (e) => {
    console.log("Password reset link sent: ", email);
    try {
      const response = await requestRetrievePassword(email);
      console.log("Password reset link sent:", response);
    } catch (error) {
      console.error("Password reset link error:", error);
    }
  };

  return (
    <div className="grid w-full place-items-center bg-gray-100">
      {expired && (
        <div className="bg-red-200 w-3/4 mt-10 -mb-10 rounded">
          Accesso scaduto
          <br />
          Effettua nuovamente il login
        </div>
      )}
      {toggleForm ? (
        <RegistrationForm
          isValidLength={isValidLength}
          isValidLowerCase={isValidLowerCase}
          isValidUpperCase={isValidUpperCase}
          isValidNumber={isValidNumber}
          isValidSpecialCharacter={isValidSpecialCharacter}
          handleRegistration={handleRegistration}
          name={name}
          setName={setName}
          lastname={lastname}
          setLastName={setLastName}
          email={email}
          setEmail={setEmail}
          password={password}
          setPassword={setPassword}
          setToggleForm={setToggleForm}
          isPasswordHidden={isPasswordHidden}
          setHidePassword={setHidePassword}
          handleEmail={handleEmail}
          handlePassword={handlePassword}
          userAlreadyExist={userAlreadyExist}
          emailSelectedRegistration={emailSelectedRegistration}
          setEmailSelectedRegistration={setEmailSelectedRegistration}
          nameSelected={nameSelected}
          setNameSelected={setNameSelected}
          lastNameSelected={lastNameSelected}
          setLastNameSelected={setLastNameSelected}
          passwordSelectedRegistration={passwordSelectedRegistration}
          setPasswordSelectedRegistration={setPasswordSelectedRegistration}
          registrationError={registrationError}
          emailError={registrationEmailError}
          passwordError={registrationPasswordError}
          firstNameError={registrationFirstNameError}
          lastNameError={registrationLastNameError}
        />
      ) : showPasswordResetForm ? (
        <PasswordResetForm
          setShowPasswordResetForm={setShowPasswordResetForm} // Aggiungi questa prop per poter tornare al form di login
          email={email}
          setEmail={setEmail}
          emailSelectedLogin={emailSelectedLogin}
          setEmailSelectedLogin={setEmailSelectedLogin}
          requestRetrievePassword={handleRetrievePassword}
        />
      ) : (
        <LoginForm
          email={email}
          setEmail={setEmail}
          password={password}
          setPassword={setPassword}
          handleLogin={handleLogin}
          setToggleForm={setToggleForm}
          isPasswordHidden={isPasswordHidden}
          setHidePassword={setHidePassword}
          emailSelectedLogin={emailSelectedLogin}
          setEmailSelectedLogin={setEmailSelectedLogin}
          passwordSelectedLogin={passwordSelectedLogin}
          setPasswordSelectedLogin={setPasswordSelectedLogin}
          loginError={loginError}
          passwordForgot={passwordForgot}
          handleLoginSuccess={handleLoginSuccess}
          handleLoginError={handleLoginError}
        />
      )}
    </div>
  );
};

export default Login;
